module.exports = __webpack_public_path__ + "img/termqifei.3dc9411a.jpg";